import { Platform } from "react-native";

import {
  Flag,
  META_WEBVIEW_LOGIN_METHODS,
  type MetaWebviewLoginMethod,
  stripExperimentVariant,
} from "@medbillai/utils/flag";

import { evaluateEnumVariation, useBoolVariation } from "./flag";

export type InAppBrowser = "facebook" | "instagram" | "threads" | "none";

export function getInAppBrowser(): InAppBrowser {
  if (Platform.OS !== "web" || typeof navigator === "undefined") {
    return "none";
  }
  const ua = navigator.userAgent;
  if (ua.includes("Barcelona")) {
    return "threads";
  }
  if (ua.includes("Instagram")) {
    return "instagram";
  }
  if (ua.includes("FBAN") || ua.includes("FBAV") || ua.includes("FB_IAB")) {
    return "facebook";
  }
  return "none";
}

/**
 * Which sign-in email a Meta in-app browser gets; null in any other browser.
 * Read as the email is sent, so only in-app senders enrol in the experiment.
 */
export const metaWebviewLoginMethod = (): MetaWebviewLoginMethod | null =>
  getInAppBrowser() === "none"
    ? null
    : evaluateEnumVariation(
        META_WEBVIEW_LOGIN_METHODS,
        Flag.META_WEBVIEW_LOGIN_METHOD,
        "code",
      );

/**
 * Whether email login should lead with a link that opens in any browser.
 * A Meta in-app browser's storage never reaches Safari, so only a link without
 * PKCE carries the member out signed in.
 */
export const sendsCrossBrowserLink = (
  method: MetaWebviewLoginMethod | null,
): boolean => method !== null && stripExperimentVariant(method) === "link";

/**
 * Nobody is signed into Google or Apple inside an in-app browser, so signing in
 * there again costs more than typing an email.
 */
export const canOfferProviderSignIn = (): boolean =>
  getInAppBrowser() === "none";

export const useNateraIntakeOAuth = (): boolean => {
  const enabled = useBoolVariation(Flag.NATERA_INTAKE_OAUTH, false);
  return enabled && Platform.OS === "web" && canOfferProviderSignIn();
};
